export default __webpack_public_path__ + "static/media/organization.6c7c104d.svg";